import NextImage from 'next/image';
import { ShopTypes, UmbracoTypes } from '~/lib/data-contract';
import { useTranslations } from '~/services/umbraco/hooks';
import { EU_GARAN_NESTED_VERSION } from './constants';
import { Container, LabelButton, TextLink } from './styled';

interface Props {
    className?: string;
    euGaranYears: number;
    onClick?: () => void;
    rightsLink?: UmbracoTypes.ILink;
}

// Matches the nested artwork's viewBox (368.5 x 56.69) at a height of 40
const WIDTH = 260;
const HEIGHT = 40;

const EUGaranLabel = ({ className, euGaranYears, onClick, rightsLink }: Props) => {
    const { translate } = useTranslations();

    const image = (
        <NextImage
            src={`/api/garan/nested/${euGaranYears}?v=${EU_GARAN_NESTED_VERSION}`}
            alt={
                translate('product.euGaran.alt', [
                    {
                        type: ShopTypes.TranslationValueType.Integer,
                        key: 'YEARS',
                        value: euGaranYears,
                    },
                ]) || 'GARAN'
            }
            width={WIDTH}
            height={HEIGHT}
            unoptimized
        />
    );

    return (
        <Container className={className}>
            {onClick ? (
                <LabelButton type="button" onClick={onClick}>
                    {image}
                </LabelButton>
            ) : (
                image
            )}

            {rightsLink?.url ? (
                <TextLink href={rightsLink.url} target={rightsLink.target}>
                    {rightsLink.text || translate('product.euGaran.rightsLink')}
                </TextLink>
            ) : null}
        </Container>
    );
};

export default EUGaranLabel;
